module.exports = __webpack_public_path__ + "static/media/Columns_Black.035d69b6.svg";